<template>
	<div ref="nav">
		<div
			class="nav"
			:class="{
				withImage: withImage,
				scrolled: scrolled,
				inverted: invert,
			}"
		>
			<nav class="navbar" >
				<div class="container">
					
					<div class="w-100 d-flex align-items-center justify-content-between">
						<router-link tag="a" :to="`/`">
							<img src="@/assets/logo.png" v-if="!invert" alt="" class="logo logo-light" />
							<img src="@/assets/logo-dark.png" v-if="invert" alt="" class="logo logo-dark" />
						</router-link>

						<div class="only-desktop" v-if="!hideMenu">
							<b-nav>
								<b-nav-item :to="`/`" active>INICIO </b-nav-item>
								<b-nav-item :to="`/quienes-somos`">QUIENES SOMOS</b-nav-item>
								<b-nav-item :to="`/lista-productos`">PRODUCTOS</b-nav-item>
								<b-nav-item :to="`/tienda`">TIENDA</b-nav-item>
								<b-nav-item :to="`/contacto`">CONTACTO </b-nav-item>
								<b-nav-item  v-if="!hideCart">
									<SearchNavbar  />
								</b-nav-item>
								<b-nav-item  v-if="!hideCart">
									<CartNavbar  />
								</b-nav-item>
							</b-nav>
						</div>

						<div class="only-mobile" v-if="!hideMenu">
							<div class="d-flex align-center justify-content-between mt-2">
								<div  class="mt-2 mr-2">
									<SearchNavbar  />
								</div>
								<router-link tag="a" to="/checkout" class="mt-2 mr-2">
									<CartNavbar  />
								</router-link>

								<b-button v-b-toggle.menu-sidebar class="btn btn-menu">
									<div class="icon-menu"></div>
									MENU
								</b-button>
							</div>
						</div>
					</div>
				</div>

				
			</nav>

			<div class="nav-spacer" ref="spacer" v-if="!navFixed"></div>

			<b-sidebar id="menu-sidebar" right shadow sidebar-class="sidebar-menu" no-header>
				<div class="d-flex justify-content-between">
					<div class="p-3">
						<img src="@/assets/logo.png" alt="" class="logo" />
					</div>
					<div class="btn btn-close p-3" v-b-toggle.menu-sidebar>
						<i class="icon icon-close"></i>
					</div>
				</div>

				<b-nav vertical class="mt-3">
					<b-nav-item to="/" class="btn-primary" active>Inicio </b-nav-item>
					<b-nav-item to="/quienes-somos" class="btn-primary">Quienes somos</b-nav-item>
					<b-nav-item to="/lista-productos" class="btn-primary">Productos</b-nav-item>
					<b-nav-item to="/tienda" class="btn-primary">Tienda</b-nav-item>
					<b-nav-item to="/contacto" class="btn-primary">Contacto </b-nav-item>
				</b-nav>
			</b-sidebar>
		</div>
	</div>
</template>

<script>
import CartNavbar from "@/components/ecommerce/CartNavbar"
import SearchNavbar from "@/components/ecommerce/SearchNavbar"

export default {
	name: "Navbar",
	components: { CartNavbar, SearchNavbar },
	props: {
		navFixed: {
			default: true
		},
		withImage: {
			default: false
		},
		transparent: {
			default: false
		},
		invert: {
			default: false
		},
		hideCart: {
			default: false
		},
		hideMenu: {
			default: false
		}
	},
	data() {
		return {
			opened: false,
			scrolled: false,
			currentRoute: null
		}
	},
	mounted() {
		window.addEventListener("scroll", this.onScroll)
	},
	beforeDestroy() {
		window.removeEventListener("scroll", this.onScroll)
	},
	methods: {
		onScroll(e) {
			window.top.scrollY > 10 ? (this.scrolled = true) : (this.scrolled = false)
		}
	},
	beforeMount() {
		this.currentRoute = this.$route.fullPath.replace("/" + this.$route.params.lang, "")
	}
}
</script>
<style scoped lang="scss">
.nav {
	.navbar {
		position: absolute;
		top: 0px;
		z-index: 1000;
		width: 100%;
		display: block;
		// background-color: #fff;
		padding: 0px;
		transition: all 0.2s ease-in-out;

		.container{
			z-index: 1000;
			padding: 0px;
		}
	
		.logo {
			max-height: 54px;
			margin: 8px 12px;
		}
		.logo-light{
			display: none;
		}

		.nav-link {
			height: 44px;
			color: #fff;
			font-weight: 500;
			font-size: 15px;	
			transition: all 0.2s ease-in-out;
		}


		.btn-menu {
			background: none;
			border: none;
			font-size: 10px;
			color: #fff;

			.icon-menu {
				width: 32px;
				height: 32px;
				background-position: center center;
				background-repeat: no-repeat;
				background-image: url("../assets/img/icon-menu.png");
				
			}

			
		}

		
	}
	&.withImage {
		
		.logo-light{
			display: block;
		}
		.navbar:before{
			content: '';
			position: absolute;
			top: 0px;
			left: 0px;
			width: 100%;
			height:120px;
			
				z-index: -1;
		}
	}

	& ::v-deep .sidebar-menu{
		background-color: #3a78c9 !important;
		color: #fff !important;
		max-width: 480px;
		width: 60vw;
		box-shadow: -1px 1px 33px -10px rgba(0,0,0,0.6) !important;

		.logo {
			max-height: 44px;
		}
		.btn-close {
			filter: invert(1);
			width: 48px;
			height: 48px;
		}

		.nav-item {
			
			.nav-link {
				padding: 0.5rem 0.75rem;
				font-weight: 500;
				color: #fff;
				font-size: 17px;
				margin-left: 18px;

				&:hover {
					color: #fff;
				}
			}
		}
	}

	&.inverted{
		.navbar{
			
			.nav-link{
				color: #000;
			}
			
			::v-deep .icon-search svg {
				filter: invert(1);
			}
			::v-deep .icon-cart svg {
				filter: invert(1);
			}
			.btn-menu{
				filter: invert(1);
				
			}
		}
	}
	
}


</style>
